import React from 'react';

export const  hospitalcodedata = [
    {
        hospitaltype_name: "DME",
        hospitalcode_name: "GMH-TPT"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "MCH-VJA"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "RIMS-ONG"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "RIMS-SKLM"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "RIMS-KDP"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "GVH-VSKP"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "KGH-VSKP"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "GGH-GTR"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "GGH-KKD"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "GGH-ATP"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "MCHSPSR-NLR"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "GGH-KNL"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "DH-NDL"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "DH-MTM"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "DH-RJY"
    }, {
        hospitaltype_name: "DME",
        hospitalcode_name: "MCH-ELR"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "DH-HPUR"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "DH-TNL"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "DH-PDTR"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "DH-AKP"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "MCH-ONG"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "MCH-VZG"
    }, {
        hospitaltype_name: "VVP",
        hospitalcode_name: "MCH-ADONI"
    }
];


